import { chunk } from 'lodash';
import React from 'react';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';
import { Image } from 'components/atoms/image';

const PropertyMobile = props => {
  const { height } = useViewport();
  const {
    property_heading,
    property_tag_word,
    property_feature_mobile_image,
  } = props.data;
  let amenities = chunk(props.props, 9);
  return (
    <div className="property-mobile-body" style={{ height }}>
      <Image src={property_feature_mobile_image} alt={'image-amenities'} />
      <div className="features">
        <div className="main-row">
          <h2 className={'heading'}>{property_heading}</h2>
          <h3>{property_tag_word}</h3>
        </div>
        <HorizontalCarousel
          cssFor={'amenities-carousel-container'}
          type={'property-amenity'}
          data={amenities}
          sectionType={'features'}
        />
      </div>
    </div>
  );
};
export default PropertyMobile;
